import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Project } from '../../models/project';

@Component({
  selector: 'cw-client-projects-tree',
  templateUrl: 'client-projects-tree.component.html',
})
export class ClientProjectsTreeComponent implements OnInit {
  @Input() projects: Project[];
  @Output() select: EventEmitter<Project> = new EventEmitter<Project>();
  selected: Project;

  constructor() {
  }

  ngOnInit() {
  }

  onSelected(project: Project) {
    this.selected = project;
    this.select.emit(this.selected);
  }

  createProject() {

  }


}



// WEBPACK FOOTER //
// ./src/app/shared/client-projects-tree/client-projects-tree.component.ts